import React from 'react';
import ChanceAddContainer from '../../containers/chancemng/ChanceAddContainer';

const ChanceAddPage = () => {
  return <ChanceAddContainer/>
};

export default ChanceAddPage;
